import './Footer.scss'
import React from 'react'

function Footer({isAbsolute}){
    //console.log(isAbsolute)
    let inLine = {}
    if(isAbsolute){
        inLine = {
            // position: "absolute",
            // bottom: "0",
            // right: "0",
            // left: "0"
        }
    }
    return(
        <footer style={inLine}>
                <div className="footer-wrapper" >
                    <div className="f-item">
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">
                        תנאי שימוש
                        </a>{" | "}
                        
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">
                            מדיניות פרטיות
                        </a>{" "}
                        {" "}
                        |{" "}
                    </div>
                    &nbsp;
                    <div className="f-item">
                        <a href="https://yit.co.il/" target="_blank">
                            עיצוב אפיון ופיתוח 
                            <div className="yit"></div>
                        </a>
                    </div>
                </div>
        </footer>
    )
}

export default Footer;
